import React from 'react'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import SchoolIcon from '@mui/icons-material/School'

import { CourseListStyle } from '../styles'
import CourseModal from '../modals/CourseModal'
import ResourceDescription from '../shared/ResourceDescription'
import ResourceList from './ResourceList'
import { openExternal } from '../../utils/safeUrl'

const CourseList = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    const secondary = (
        <>
            <ResourceDescription
                description={props.description}
                containerSx={CourseListStyle.titleContainer}
                typographyProps={{ ...CourseListStyle.description, gutterBottom: true }}
            />
            <Box sx={CourseListStyle.secondary}>
                <Typography {...CourseListStyle.text}>
                    <span style={{"fontWeight":"bold"}}>Instructor(s):</span> {props.authors}
                </Typography>
            </Box>
        </>
    )

    return (
        <ResourceList
            Icon={SchoolIcon}
            listStyle={CourseListStyle}
            modal={<CourseModal {...props} />}
            title={props.title}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
            secondaryContent={secondary}
        />
    )
}

export default CourseList
